import React from 'react';
import {Container, Table} from 'react-bootstrap';
import '../layout/main.scss';
import './browse.scss';


function Browse() {
    return (
        <div className="App">
            <div className="browse">
                <Container>
                    <div className="br-title">
                        <h4>Browse certificates</h4>
                    </div>

                    {/*
                    <div className="transactions_filters">Filters
                        <Form.Select aria-label="SelectCollection">
                            <option>Collection</option>
                            <option value="1">Spells of Genesis</option>
                            <option value="2">Crypto Kitties</option>
                            <option value="3">Blah blah</option>
                        </Form.Select>
                        <Form.Select aria-label="SelectChain">
                            <option>Blockchain</option>
                            <option value="1">Bitcoin/Counterparty</option>
                            <option value="2">Ethereum</option>
                            <option value="3">Klaytn</option>
                            <option value="4">Kusama</option>
                        </Form.Select>
                    </div> */}
                    <div className="certificates_table">
                        <Table bordered hover id="certiftable">
                            <thead>
                            <tr>
                                <th>Cert ID</th>
                                <th>Status</th>
                                <th>NFT name</th>
                                <th>Chain</th>
                                <th>Contract</th>
                                <th>Token ID</th>
                                <th>KIW staked</th>
                                <th></th>
                                <th>Judge</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>001</td>
                                <td>VALID</td>
                                <td>There was a book</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>001</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Shabi</td>
                            </tr>
                            <tr>
                                <td>002</td>
                                <td>VALID</td>
                                <td>The Wizard of Oz</td>
                                <td>Bitcoin</td>
                                <td>0xe4u21...d491</td>
                                <td>002</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Antonino</td>
                            </tr>
                            <tr>
                                <td>003</td>
                                <td>VALID</td>
                                <td>Back to the Future</td>
                                <td>Bitcoin</td>
                                <td>0xe4u21...d491</td>
                                <td>003</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Kéta</td>
                            </tr>
                            <tr>
                                <td>004</td>
                                <td>VALID</td>
                                <td>Metaverse reality check</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>004</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Yeye</td>
                            </tr>
                            <tr>
                                <td>005</td>
                                <td>VALID</td>
                                <td>Rock the Meta!</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>005</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Pierre</td>
                            </tr>
                            <tr>
                                <td>006</td>
                                <td>VALID</td>
                                <td>Sherlock Holmes</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>006</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Lulu</td>
                            </tr>
                            <tr>
                                <td>007</td>
                                <td>VALID</td>
                                <td>The Neverending Story</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>007</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Mila</td>
                            </tr>
                            <tr>
                                <td>008</td>
                                <td>VALID</td>
                                <td>Space Jam</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>008</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Adeline</td>
                            </tr>
                            <tr>
                                <td>009</td>
                                <td>VALID</td>
                                <td>Finding Meta</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>009</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Audrey</td>
                            </tr>
                            <tr>
                                <td>010</td>
                                <td>VALID</td>
                                <td>When does it start?</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>010</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Julien</td>
                            </tr>
                            <tr>
                                <td>011</td>
                                <td>VALID</td>
                                <td>Activate!</td>
                                <td>Ethereum</td>
                                <td>0xe4u21...d491</td>
                                <td>011</td>
                                <td>20</td>
                                <td>View</td>
                                <td>Sarah</td>
                            </tr>
                            </tbody>
                        </Table>
                    </div>

                </Container>
            </div>
        </div>
    );
}

export default Browse;
